import { gql } from "graphql-request";

export const SearchPublicRecordings = gql`
  query SearchPublicRecordings(
    $firebaseUserId: ID!
    $query: String
    $distanceMetersMin: Int
    $distanceMetersMax: Int
    $elevationGainMetersMin: Int
    $elevationGainMetersMax: Int
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
    $sort: String
    $page: Int
    $perPage: Int
  ) {
    searchPublicRecordings(
      firebaseUserId: $firebaseUserId
      query: $query
      distanceMetersMin: $distanceMetersMin
      distanceMetersMax: $distanceMetersMax
      elevationGainMetersMin: $elevationGainMetersMin
      elevationGainMetersMax: $elevationGainMetersMax
      startDate: $startDate
      endDate: $endDate
      sort: $sort
      page: $page
      perPage: $perPage
    ) {
      id
      title
      distanceMeters
      thumbnailUrl
      obfuscatedSlug
      createdAt
      shareableUrl
      elapsedSeconds
      elevationGainMeters
      lineString
      timeStamps
      public
      user {
        id
      }
      images {
        id
        file {
          url
          smUrl
          mdUrl
          lgUrl
          processed
        }
      }
      trail {
        id
        name
        trailDistance
        durationString
        shortAddress
        staticMapImage
        slug
        regionSlug
        countrySlug
      }
    }
  }
`;
